var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message.alert)?_c('div',{staticClass:"message"},[_c('div',{staticClass:"message-alert"},[_c('v-alert',{attrs:{"dense":"","border":"left","text":"","type":_vm.message.styleTypeAlert,"icon":_vm.showAlertType(_vm.message.type)}},[_vm._v(" "+_vm._s(_vm.message.message)+" ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }